export const mapOptions: google.maps.MapOptions = {
    streetViewControl: false,
    fullscreenControl: false,
    clickableIcons: false,
    styles: [
        {
            featureType: 'poi',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit.station.bus',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
    ],
}

export const circleOptions = {
    zIndex: 1,
    visible: true,
    strokeWeight: 1,
    editable: false,
    draggable: false,
    clickable: false,
    fillOpacity: 0.15,
    strokeOpacity: 0.1,
    fillColor: '#FF0000',
    strokeColor: '#FF0000',
}
